module.exports = __webpack_public_path__ + "img/hwc_5.b1f3632a.png";